import React from "react";
import { ASSETS } from "../../../../../../utils/config";
import styled from "styled-components";
import { useSelector } from "react-redux";

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 6px;
  margin-top: 10px;
  cursor: pointer;
`;

function Preset({ handleSelectWallpaper, bgWallpaper }) {
  const { wallpapersReducer } = useSelector((state) => state);

  return (
    <GridContainer>
      {wallpapersReducer.wallpapers.map((p, index) => (
        <img
          onClick={() => handleSelectWallpaper(p)}
          key={index}
          style={{
            width: "100%",
            height: "40px",
            borderRadius: "5px",
            border: bgWallpaper === p && "2px solid #99439D",
          }}
          alt="pattern"
          src={p}
        />
      ))}
    </GridContainer>
  );
}

export default Preset;
